import type { NextPage } from 'next';
import PageMetaData from '../components/page-meta-data';
import NotFound from '../components/not-found';

const NotFoundPage: NextPage = () => {
  return (
    <>
      <PageMetaData title={'Not Found'} />
      <NotFound />
    </>
  );
};

export default NotFoundPage;
